import { create } from 'zustand';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  accessExpire: number | null;
  setTokens: (tokens: {
    accessToken: string;
    refreshToken: string;
    accessExpire: number;
  }) => void;
  clearTokens: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  refreshToken: null,
  accessExpire: null,
  setTokens: ({ accessToken, refreshToken, accessExpire }) =>
    set({ accessToken, refreshToken, accessExpire }),
  clearTokens: () =>
    set({ accessToken: null, refreshToken: null, accessExpire: null })
}));
